import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/_main.scss";
import { App } from "./App";
import { ErrorBoundary } from "react-error-boundary";
import reportWebVitals from "./reportWebVitals";
import { CrashScreen } from "./components/CrashScreen";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";

import * as Sentry from "@sentry/react";
import { projectSelector } from "@rflocal/shared";

if (!projectSelector.isLocal()) {
    Sentry.init({
        environment: projectSelector.env(),
        dsn: projectSelector.sentryDsn(),
        sendDefaultPii: false, // GDPR compliance

        // session recording;
        replaysSessionSampleRate: projectSelector.env() === "prod" ? 0.1 : 0.0, //10% in prod, 0% otherwise
        replaysOnErrorSampleRate: 1.0, // in case of error, 100% errors
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
                blockAllMedia: true
            }),
            Sentry.replayCanvasIntegration()
        ]
    });
}

const posthogConfig = projectSelector.posthogConfig?.();
if (posthogConfig?.enabled && posthogConfig.apiKey) {
    posthog.init(posthogConfig.apiKey, {
        api_host: posthogConfig.apiHost,
        defaults: "2025-11-30",
        disable_session_recording: projectSelector.isLocal(),
        capture_pageview: false
    });
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <ErrorBoundary
            FallbackComponent={CrashScreen}
            onError={(error, info) => {
                Sentry.captureException(error, {
                    contexts: { react: { componentStack: info.componentStack } }
                });
            }}
            onReset={(details) => {
                // best to just do a full reload, since state may be corrupted
                window.location.reload();
            }}
        >
            <PostHogProvider client={posthog}>
                <App />
            </PostHogProvider>
        </ErrorBoundary>
    </React.StrictMode>
);

reportWebVitals();
